export const DEFAULT_PAGE_SIZE = 25
export const DEFAULT_EQUIPMENT_PAGE_SIZE = 25
export const DEFAULT_INCIDENT_TIMELINE_PAGE_SIZE = 25
export const DEFAULT_OFFSET = 0
export const DEFAULT_SEARCHABLE_SELECT_PAGE_SIZE = 100
export const DEFAULT_SIGNAL_ROLLUPS_PAGE_SIZE = 25
export const DEFAULT_SELECTION_LIST_LIMIT = 500
export const DEFAULT_LARGE_SELECTION_LIST_LIMIT = 5000
export const STANDARD_PAGE_SIZE_OPTIONS = [25, 50, 100]
// A smaller default for tables that sit below extra chrome (e.g. the tabbed
// notification log/subscriptions grids) so fewer rows scroll within the grid.
export const COMPACT_PAGE_SIZE = 20
export const COMPACT_PAGE_SIZE_OPTIONS = [20, 50, 100]
